/* eslint-disable react-native/no-inline-styles */
import {
  View,
  Text,
  Image,
  useWindowDimensions,
  ViewStyle,
  ImageStyle,
  TextStyle,
  Linking,
  TouchableOpacity,
} from 'react-native';
import React from 'react';
import {HyperLinkSection} from './Section';
import {staticDataForScreen} from 'constants/DefaultValues';
import {spacing} from 'theme/Units';

const LinksMap = staticDataForScreen.landing_screen.footerLinks;

export function Footer() {
  const waterMark = require('assets/images/watermark_logo.png');
  const whiteLogo = require('assets/images/logo_white.png');
  const facebook = require('assets/icons/facebook.png');
  const linkedin = require('assets/icons/linkedin.png');
  const {width: SCREEN_WIDTH} = useWindowDimensions();
  const overrideStyle = structuredClone(styles);

  if (SCREEN_WIDTH < 980) {
    overrideStyle.hyperLinks.display = 'grid';
    overrideStyle.hyperLinks.gridTemplateColumns = '1fr 1fr';
    overrideStyle.hyperLinks.rowGap = spacing['8'];
    overrideStyle.footer.paddingHorizontal = spacing['14'];
    overrideStyle.footer.paddingVertical = spacing['10'];
    overrideStyle.waterMark.width = 300;
  }
  if (SCREEN_WIDTH < 800) {
    overrideStyle.footer.flexDirection = 'column';
    overrideStyle.footer.gap = spacing['4'];
    overrideStyle.hyperLinks.rowGap = spacing['6'];
    overrideStyle.linksAndContacts.marginLeft = 0;

    overrideStyle.socialLinks.display = 'none';
    overrideStyle.socialsLinks2.display = 'flex';

    overrideStyle.footer.paddingHorizontal = spacing['12'];
    overrideStyle.footer.paddingVertical = spacing['8'];
    overrideStyle.waterMark.width = 270;
  }

  if (SCREEN_WIDTH < 720) {
    overrideStyle.footer.paddingHorizontal = spacing['8'];
    overrideStyle.footer.paddingVertical = spacing['6'];
    overrideStyle.waterMark.width = 240;
    overrideStyle.hyperLinks.gridTemplateColumns = '1.3fr .7fr';
  }

  return (
    <View style={[styles.footer, overrideStyle.footer]}>
      {/* socials account */}
      <View style={styles.socials}>
        <View style={styles.socialLinks}>
          <Image style={styles.logo} source={whiteLogo} />
          <Text
            style={[styles.boldText, SCREEN_WIDTH < 800 && {display: 'none'}]}>
            © 2025 1IDP. All Rights Reserved.
          </Text>
        </View>

        <View style={[styles.socialLinks, overrideStyle.socialLinks]}>
          <Text style={styles.boldText}>Connect with us</Text>
          <View
            style={styles.rowGap28}>
            <TouchableOpacity
              onPress={() =>
                Linking.openURL(
                  'https://www.facebook.com/profile.php?id=61571253033507',
                )
              }>
              <Image style={styles.icon} source={facebook} />
            </TouchableOpacity>
            {/* un-used */}
            {/* <Image style={styles.icon} source={twitter} /> */}
            <TouchableOpacity
              onPress={() =>
                Linking.openURL(
                  'https://www.linkedin.com/showcase/1-idp/about/',
                )
              }>
              <Image style={styles.icon} source={linkedin} />
            </TouchableOpacity>
          </View>
        </View>
      </View>

      {/* section with usefull link to be displayed */}
      <View style={[styles.linksAndContacts, overrideStyle.linksAndContacts]}>
        <View style={[styles.hyperLinks, overrideStyle.hyperLinks]}>
          {LinksMap.map(item => {
            return (
              <HyperLinkSection
                key={item.id}
                links={item.links}
                title={item.title}
              />
            );
          })}
        </View>
        {/* hidden for later */}
        {/* <View style={{color: 'white', paddingBottom: 60}}>
          <Text style={{color: 'white', fontSize: 18, fontWeight: '500'}}>
            Stay updated with the latest features and news
          </Text>
        </View> */}
      </View>

      <Image
        source={waterMark}
        style={[styles.waterMark, overrideStyle.waterMark]}
      />

      <View style={[styles.socialsLinks2, overrideStyle.socialsLinks2]}>
        <Text style={styles.boldText}>Connect with us</Text>
        <View
          style={styles.rowGap28}>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL(
                'https://www.facebook.com/profile.php?id=61571253033507',
              )
            }>
            <Image style={styles.icon} source={facebook} />
          </TouchableOpacity>

          {/* hidden for later */}
          {/* <TouchableOpacity
            onPress={() =>
              Linking.openURL(
                '#',
              )
            }>
            <Image style={styles.icons} source={twitter} />
          </TouchableOpacity> */}

          <TouchableOpacity
            onPress={() =>
              Linking.openURL('https://www.linkedin.com/showcase/1-idp/about/')
            }>
            <Image style={styles.icon} source={linkedin} />
          </TouchableOpacity>
        </View>

        <Text style={styles.boldText}>© 2025 1IDP. All Rights Reserved.</Text>
      </View>
    </View>
  );
}

type styleType = {
  footer: ViewStyle;
  socials: ViewStyle;
  linksAndContacts: ViewStyle;
  hyperLinks: ViewStyle;
  logo: ImageStyle;
  boldText: TextStyle;
  waterMark: ImageStyle;
  socialLinks: ViewStyle;
  socialsLinks2: ViewStyle;
  icon: ImageStyle;
  rowGap28: ViewStyle;
};

let styles: styleType = {
  footer: {
    width: '100%',
    backgroundColor: '#393C46',
    paddingHorizontal: spacing['16'],
    paddingVertical: spacing['12'],
    position: 'relative',
    flexDirection: 'row',
  },
  icon: {width: 32, height: 32},
  socials: {
    gap: 64,
  },

  socialLinks: {
    gap: 16,
  },
  rowGap28: {
    flexDirection: 'row',
    gap: 28,
  },
  linksAndContacts: {
    flex: 1,
    marginLeft: 150,
  },
  hyperLinks: {
    flexDirection: 'row',
    flex: 1,
  },
  logo: {
    width: 120,
    height: 70,
    resizeMode: 'contain',
  },
  boldText: {
    color: '#ffffff',
    fontSize: 15,
  },

  waterMark: {
    width: 330,
    height: 200,
    position: 'absolute',
    resizeMode: 'contain',
    bottom: 0,
    left: 0,
    zIndex: -10,
  },

  socialsLinks2: {
    gap: 16,
    display: 'none',
  },
};
